import { ViewObjectContainerSaveableSettingsProvider } from "./view-object-container-saveable-settings-provider";

export class TableSaveableSettingsProvider extends ViewObjectContainerSaveableSettingsProvider {
  constructor(viewObjectProviders) {
    super(viewObjectProviders);
  }

  createSaveableSettings(settings) {
    if (settings.items === undefined) {
      return {
        items: []
      };
    }
    const parsedRows = [];
    for (let rowIndex = 0; rowIndex < settings.items.length; rowIndex++) {
      const rowSettings = settings.items[rowIndex];
      const rowInfo = [];
      for (let columnIndex = 0; columnIndex < rowSettings.length; columnIndex++) {
        const itemSettings = this.createItemSettings(rowSettings[columnIndex]);
        rowInfo.push(itemSettings);
      }
      parsedRows.push(rowInfo);
    }
    return {
      items: parsedRows
    };
  }

  applySaveableSettings(settings, saveableSettings) {
    if (settings.items === undefined || saveableSettings.items === undefined || settings.items.length != saveableSettings.items.length) {
      return;
    }
    for (let rowIndex = 0; rowIndex < settings.items.length; rowIndex++) {
      const rowSettings = settings.items[rowIndex];
      const saveableRowSettings = saveableSettings.items[rowIndex];
      if (rowSettings.length == saveableRowSettings.length) {
        for (let columnIndex = 0; columnIndex < rowSettings.length; columnIndex++) {
          this.applyItemSettings(rowSettings[columnIndex], saveableRowSettings[columnIndex]);
        }
      }
    }
  }
}
